import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getAlertaPlanoDeAcao } from "./services";
import { TRequestPlanoDeAcao } from "./types";
import { AxiosError } from "axios";

interface PlanoDeAcaoState {
  status: "idle" | "loading" | "success" | "error";
  data: any;
  error: string | null;
}

const initialState: PlanoDeAcaoState = {
  status: "idle",
  data: null,
  error: null,
};

export const actionGetAlertaPlanoDeAcao = createAsyncThunk<
  any,
  TRequestPlanoDeAcao,
  { rejectValue: string }
>("ACTION_GET_ALERTA_PLANO_DE_ACAO", async (data, { rejectWithValue }) => {
  if (!data?.id) {
    return rejectWithValue("ID inválido");
  }
  try {
    const response = await getAlertaPlanoDeAcao(data);
    return response;
  } catch (err) {
    const error = err as AxiosError;
    const mensagem = error.response?.data || "Erro desconhecido";
    return rejectWithValue(mensagem as string);
  }
});

export const sliceGetAlertaPlanoDeAcao = createSlice({
  name: "GET_ALERTA_PLANO_DE_ACAO",
  initialState,
  reducers: {
    actionResetGetAlertaPlanoDeAcao: (state) => {
      state.status = "idle";
      state.data = null;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(actionGetAlertaPlanoDeAcao.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(actionGetAlertaPlanoDeAcao.fulfilled, (state, action) => {
        state.status = "success";
        state.data = action.payload;
        state.error = null;
      })
      .addCase(actionGetAlertaPlanoDeAcao.rejected, (state, action) => {
        state.status = "error";
        state.error = action.payload || "Erro desconhecido";
      });
  },
});

export default sliceGetAlertaPlanoDeAcao.reducer;
export const { actionResetGetAlertaPlanoDeAcao } =
  sliceGetAlertaPlanoDeAcao.actions;
